<template>
    <span :class="[classes.base, classes.variants.theme[theme]]">
        <slot></slot>
    </span>
</template>

<script setup>
const props = defineProps({
    theme: {
        type: String,
        default: "info"
    }
});

const classes = {
    base: "text-xs font-semibold mx-2 px-2.5 py-0.5 rounded",

    variants: {
        theme: {
            info: "bg-blue-100 text-blue-800",
            gray: "bg-gray-100 text-gray-800",
            danger: "bg-red-100 text-red-800",
            success: "bg-green-100 text-green-800",
            warning: "bg-warning text-dark",
            primary: "bg-purple-100 text-purple-300"
        }
    }
};
</script>

<style scoped>

</style>
